<template>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-1/2">
      <user-account-details-basic-information-basic/>
    </div>

    <div class="vx-col w-full lg:w-1/2 mt-base pt-base lg:mt-0 lg:pt-0">
      <user-account-details-basic-information-notification-preferences/>
    </div>
  </div>
</template>

<script>
import UserAccountDetailsBasicInformationBasic from '@/views/modules/user/user-account/user-account-details/UserAccountDetailsBasicInformationBasic.vue';
import UserAccountDetailsBasicInformationNotificationPreferences from '@/views/modules/user/user-account/user-account-details/UserAccountDetailsBasicInformationNotificationPreferences.vue';

/**
 * Component to allow the user view and update its profile
 *
 * @module views/modules/user-account/UserAccountProfileGeneral
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 */
export default {
  name: 'UserAccountDetailsBasicInformation',
  components: {
    UserAccountDetailsBasicInformationBasic,
    UserAccountDetailsBasicInformationNotificationPreferences,
  },

};
</script>
